import { Modal } from 'bootstrap';

( ( $ ) => {

	$( ".card--video, .highlight-video, .modal-video a" ).on( 'click', ( ev ) => {

		const the_modal	= new Modal( '#modal-large' );
		const video_id	= $( ev.currentTarget ).data( 'video-id' );
		const template	= wp.template( 'modal-large--video' );

		if ( ! video_id || ! the_modal || ! template )
		{
			return;
		}

		$.getJSON( '/wp-json/wp/v2/embedded_video/' + video_id, ( response ) => {

			const modal_data = {
				content : response.content.rendered,
			};

			const modal_content = template( modal_data );

			$( the_modal._element )
				.addClass( 'modal--video' )
				.on( 'hidden.bs.modal', ( ev ) => {
					$( the_modal._element )
						.find( '.modal-background' )
						.removeClass( 'd-none' );
					$( the_modal._element )
						.removeClass( 'modal--video' )
						.find( '.modal-body' )
						.html( '' );
				} )
				.find( '.modal-body' )
				.html( modal_content );

			$( the_modal._element )
				.find( '.modal-background' )
				.addClass( 'd-none' );

			the_modal.show();
		} );
	
		ev.preventDefault();
	});

} )( jQuery );